export default "assets/images/logo-small-e7dd24bf.png";